
<div id="content" class="main-content" style="margin-bottom: 22vh;">
    <div class="container">
        <div class="page-header">
            <div class="page-title">
                <h2><b>Tableau de bord</b></h2>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-4 col-lg-6 col-md-6 col-12 layout-spacing">
                <div class="widget-content-area chat-messages p-0 br-4 h-100">
                    <div class="chat-container">
                        <div class="chat-header p-0">
                            <div class="media align-items-center" (click)="loadLastRequests()" style="cursor: pointer;">
                                <img src="../../assets/img/suivitim_img/warning.gif" style="width: 55px; height: 45px; margin: 3%; border: 0;" alt="alert">
                                <div class="media-body">
                                    <h6 class="mb-0">Tickets ouverts</h6>
                                </div>
                            </div>
                        </div>
        
                        <div class="chat-body reload-widget-area">
                            <div class="mCustomScrollbar message-scroll" data-mcs-theme="minimal-dark">
                                <div *ngIf="lastTicketsLoading" class="cp-spinner cp-bubble" 
                                    style="margin: auto; display: block; margin-top: 15%; margin-bottom: 15%;"></div>
                                <div *ngIf="lastTickets.length === 0 && !lastTicketsLoading" class="no-tickets-message">
                                    <p>Aucun ticket disponible pour ce statut.</p>
                                </div>
                                <div class="table-responsive"  *ngIf="!lastTicketsLoading && lastTickets.length>0">
                                    <table class="table table-lastTicket">
                                        <tbody>
                                            <tr *ngFor="let ticket of lastTickets"  [routerLink]="['/ticket/detail', ticket.uuid]" style="cursor: pointer;">
                                                <td>
                                                    <div class="media py-2 pl-2">
                                                        <img class="usr-img rounded-circle mr-4" [src]="ticket?.avatar ? 'data:image/jpeg;base64,' + ticket?.avatar : '../../assets/img/unknown_user.jpg'" alt="Profile" >
                                                        <div class="media-body">
                                                            <h6 class="usr-name mb-2">{{ ticket.creator }}</h6>
                                                            <p class="text-sm"><b>{{ ticket.organisation }}</b></p>
                                                            <p class="message">{{ (ticket.description?.length>30)? (ticket.description | slice:0:25)+'...':(ticket.description!) }}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="text-right"><p class="meta-time pr-3">{{ formatTimeDifference(ticket.createdAt) }}</p></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="text-center show-all-msg p-4">
                                <a routerLink="/tickets">tous les tickets</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            <div class="col-xl-8 col-lg-12 col-md-12 col-12 layout-spacing">
                <div class="widget-content-area monthly-chart h-100 br-4">
                    <div class="row">
                        <div class="col-lg-12 col-md-6 col-sm-10 col-12 mt-sm-0 mt-3">
                          <ul class="nav justify-content-center monthly-chart-tab nav-pills" id="monthly-chart" role="tablist">
                            <li class="nav-item">
                              <a class="nav-link" [ngClass]="{'active': currentStatus === 1}" (click)="changeStatus(1)">Ouvert</a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" [ngClass]="{'active': currentStatus === 2}" (click)="changeStatus(2)">Résolu</a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" [ngClass]="{'active': currentStatus === 3}" (click)="changeStatus(3)">Repris</a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" [ngClass]="{'active': currentStatus === 4}" (click)="changeStatus(4)">En cours</a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" [ngClass]="{'active': currentStatus === 5}" (click)="changeStatus(5)">En attente</a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" [ngClass]="{'active': currentStatus === 6}" (click)="changeStatus(6)">Clos</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-12 col-md-12 col-12 mt-3">
                          <div class="tab-content" id="monthly-chartContent">
                            <div *ngIf="ticketsLoading" class="cp-spinner cp-bubble" style="margin: auto; display: block; margin-top: 15%; margin-bottom: 15%;"></div>
                            <div *ngIf="!ticketsLoading" class="v-pv-weekly" style="height: 100%; width: 100%; margin-top: 30px;">
                                <div *ngIf="groupedTickets.length === 0" class="no-tickets-message">
                                    <p>Aucun ticket disponible pour ce statut.</p>
                                  </div>
                                  <div *ngFor="let group of groupedTickets" class="row">
                                    <div *ngFor="let ticket of group" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-xl-0">
                                        <div class="ribbon">
                                            <div class="widget-content widget-content-area mb-2 br-6 position-relative">
                                                <img *ngIf="ticket.avatar" [src]="'data:image/jpeg;base64,' + ticket.avatar" class="avatar-img rounded-circle position-absolute" alt="avatar">
                                                <h6 class="mb-2 h6-title"><b>{{ ticket.creator }}</b> - {{ ticket.organisation }}</h6>
                                                <p class="mt-1"><b>{{ ticket.subject }}</b></p>
                                                <p class="text-sm">N° du ticket : <b>{{ ticket.ticketNumber }}</b></p>
                                                <p class="mt-1">{{ (ticket.description?.length>55)? (ticket.description | slice:0:50)+'...':(ticket.description!) }}</p>
                                                <a [routerLink]="['/ticket/detail', ticket.uuid]" class="detail-link">Voir détails</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                          </div>
                        </div>
                      </div>
                      
                </div>
            </div>
        </div>
    </div>
</div>